// src/url.js
export default {
    // user apis
    user: {
      login: '/user/login',
    },
    // categories apis
    categories: {
        get: 'categories/',
        post: 'categories/', 
        update: 'categories/:pk/', 
    },
    // sub categories apis
    sub_categories: {
      get: 'sub_categories/',
      post: 'sub_categories/', 
      update: 'sub_categories/:pk/', 
    },
    // item size api's
    item_size: {
        get: 'item_size/',
        post: 'item_size/',
        update: 'item_size/:pk/',
    },
    // item color api's
    item_color: {
        get: 'item_color/',
        post: 'item_color/',
        update: 'item_color/:pk/',
    },
    // inventory store api's
    inventory_store: {
        get: 'inventory_store/',
        post: 'inventory_store/',
        update: 'inventory_store/:pk/',
    },
    // inventory warehouse api's
    inventory_warehouse: {
        get: 'inventory_warehouse/',
        post: 'inventory_warehouse/',
        update: 'inventory_warehouse/:pk/',
    },
    // inventory supplier api's
    inventory_supplier: {
        get: 'inventory_supplier/',
        post: 'inventory_supplier/',
        update: 'inventory_supplier/:pk/',
    },
    // measurement unit api's
    measurement_unit: {
        get: 'measurement_unit/',
        post: 'measurement_unit/',
        update: 'measurement_unit/:pk/',
    },
    // item api's
    item: {
        get: 'item/',
        post: 'item/',
        update: 'item/:pk/',
    },
    // income head api's
    income_head: {
        get: 'income_cat/',
        post: 'income_cat/',
        update: 'income_cat/:pk/',
    },

    income_head_sub: {
        get: 'income_sub_cat/',
        post: 'income_sub_cat/',
        update: 'income_sub_cat/:pk/',
    },

    expense_head: {
        get: 'expense_head/',
        post: 'expense_head/',
        update: 'expense_head/:pk/',
    },

    expense_sub_head: {
        get: 'expense_sub_head/',
        post: 'expense_sub_head/',
        update: 'expense_sub_head/:pk/',
    },

    supplier_head: {
        get: 'supplier_head/',
        post: 'supplier_head/',
        update: 'supplier_head/:pk/',
    },

    supplier_sub_head: {
        get: 'supplier_sub_head/',
        post: 'supplier_sub_head/',
        update: 'supplier_sub_head/:pk/',
    },

    customer_head: {
        get: 'customer_head/',
        post: 'customer_head/',
        update: 'customer_head/:pk/',
    },

    customer_sub_head: {
        get: 'customer_sub_head/',
        post: 'customer_sub_head/',
        update: 'customer_sub_head/:pk/',
    },

    bank_account_head: {
        get: 'bank_account_head/',
        post: 'bank_account_head/',
        update: 'bank_account_head/:pk/',
    },

    item_search: {
        get: 'api/search_item/'
    },

    pos_pay: {
       post: 'api/pos/payment/'
    },

    inv_batch: {
        get: 'batches/',
        post: 'batch/create/'
    },

    batch_cash_type: {
        get: 'batch/cash/type/',
    },

    batch_item_search: {
        get: 'batch/item/search/',
    },

    batch_receive_no: {
        get: 'batch/receive/number/',
    },

    batch_bank_account: {
        get: 'batch/bank/account/',
    },

    pos_new_invoice: {
        get: 'pos/new/invoice/',
    },

    customers: {
        get: 'customers/',
        post: 'customers/',
        update: (id) => `customers/${id}/`,
    },

    customer_search: {
        get: 'customer/search/'
    },

    setting: {
        get: 'setting/',
        update: (id) => `setting/${id}/`,
    },

    payment_type: {
        get: 'payment/type/'
    },

    customer_due: {
        get: 'customer/due/'
    },

    customer_due_receive_number: {
        get: 'customer/due/receive/number/'
    },

    customer_payment: {
        post: 'customer/due/payment/',
        get: 'customer/due/payment/'
    },

    supplier_due_receive_number: {
        get: 'supplier/due/receive/number/'
    },

    supplier_search: {
        get: 'supplier/search/'
    },

    supplier_due: {
        get: 'supplier/due/'
    },

    supplier_payment: {
        post: 'supplier/due/payment/',
        get: 'supplier/due/payment/'
    },

    damage_receive_number: {
        get: 'damage/receive/number/'
    },

    damage_item: {
      post: 'damage/item/'
    },

    voucher_search: {
        get: 'voucher/search/'
    },

    voucher_item_search: {
        get: 'voucher/item/search/'
    },

    return_receive_number: {
        get: 'return/receive/number/'
    },

    return_item: {
      post: 'return/item/',
      get: 'return/item/'
    },

    // report file urls
    item_return_report: {
      get: 'item/return/report/'
    },

    item_stock_report: {
      get: 'item/stock/report/'
    },

    inventory_batch_report: {
        get: 'inventory/batch/report/'
    },

    inventory_sell_report: {
        get: 'inventory/sell/report/'
    },

    inventory_buy_report: {
        get: 'inventory/buy/report/'
    },

    inventory_low_stock_report: {
        get: 'inventory/low/stock/report/'
    },

    customers_due_report: {
        get: 'customers/due/report/'
    },

    suppliers_payment_report: {
        get: 'suppliers/payment/report'
    },

    item_warehouse: {
        get: 'item/warehouse/'
    },

    item_warehouse_qty: {
        get: 'item/warehouse/quantity/'
    },

    purchase_return_receive_number: {
        get: 'purchase/return/receive/number/'
    },

    purchase_return: {
        post: 'purchase/return/',
        get: 'purchase/return/'
    },

    purchase_voucher_search: {
        get: 'purchase/voucher/search/'
    },

    purchase_voucher_item_search: {
        get: 'purchase/voucher/item/search/'
    },

    users: {
      get: 'users/',
      post: 'users/create/',
      detail: id => `users/${id}/`,
      update: id => `users/${id}/`,
      delete: id => `users/${id}/`,
    },

    roles: {
      get: 'user/roles/',
      post: 'user/roles/',
      detail: id => `user/roles/${id}/`,
      update: id => `user/roles/${id}/`,
      delete: id => `user/roles/${id}/`,
    },

    cash_amount: {
        get: 'cash/amount/'
    },

    bank_amount: {
        get: 'bank/amount/'
    },

    income_amount: {
        get: 'income/amount/'
    },

    expense_amount: {
        get: 'expense/amount/'
    },

    discount_amount: {
        get: 'discount/amount/'
    },

    pos_receivable_amount: {
        get: 'pos/receivable/amount/'
    },

    vat_payable_amount: {
        get: 'vat/payable/amount/'
    },

    supplier_bill_payable_amount: {
        get: 'supplier/bill/payable/amount/'
    },

    stores: {
        get: 'store/list/'
    },

    pos_best_selling: {
        get: 'pos/best/selling/'
    },

    login_user: {
        get: 'user/login/user/'
    },

    vat_group: {
        get: 'vat_group/',
        post: 'vat_group/',
        update: 'vat_group/:pk/',
    },

    item_vat: {
        get: 'item/vat/'
    },

    change_password: {
        post: 'change/password/'
    },

    print_barcodes: {
        post: 'print/barcodes/'
    },

    invoice_print: {
        get: 'invoice/print/'
    },

    dashboard_data: {
        get: 'dashboard/data/'
    },

    recent_item: {
        get: 'recent/item/'
    },

    expire_item: {
        get: 'expire/item/'
    },

    chart_data: {
        get: 'dashboard/chart/'
    },

    invoice_setting: {
        post: 'invoice_setting/',
        get: 'invoice_setting/',
        update: (id) => `invoice_setting/${id}/`,
    },

};
